"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areEqualBinaries = exports.hexToBinary = exports.binaryToHex = exports.utf8ToBinary = exports.binaryToUtf8 = void 0;
const textEncoder = new TextEncoder();
const textDecoder = new TextDecoder();
const binaryToUtf8 = (bytes) => {
    return textDecoder.decode(bytes);
};
exports.binaryToUtf8 = binaryToUtf8;
const utf8ToBinary = (utf8) => {
    return textEncoder.encode(utf8);
};
exports.utf8ToBinary = utf8ToBinary;
const binaryToHex = (bytes, addPrefix = false) => {
    if (addPrefix) {
        return `0x${Buffer.from(bytes).toString('hex')}`;
    }
    return Buffer.from(bytes).toString('hex');
};
exports.binaryToHex = binaryToHex;
const hexToBinary = (hex) => {
    if (hex.startsWith('0x')) {
        hex = hex.slice(2);
    }
    if (hex.length % 2 !== 0) {
        throw new Error(`Hex string length must be even, received: 0x${hex}`);
    }
    const result = Buffer.from(hex, 'hex');
    if (hex.length !== result.length * 2) {
        throw new Error(`Hex string input is likely malformed, received: 0x${hex}`);
    }
    return result;
};
exports.hexToBinary = hexToBinary;
const areEqualBinaries = (arr1, arr2) => {
    return Buffer.compare(arr1, arr2) === 0;
};
exports.areEqualBinaries = areEqualBinaries;
//# sourceMappingURL=binaryUtils.js.map